(() => {
  const garage = document.querySelector('[data-vehicle-garage]');
  if (!garage) return;
  const key = 'amoffroad.vehicle.v1';
  const param = 'filter.p.m.amoffroad.vehicle';
  const form = document.querySelector('[data-garage-form]');
  const dialog = document.querySelector('#VehicleFinder');
  const parts = document.querySelector('#PartsFinder');
  const year = form.querySelector('[data-garage-year]');
  const make = form.querySelector('[data-garage-make]');
  const model = form.querySelector('[data-garage-model]');
  const feedback = form.querySelector('[data-garage-feedback]');
  const normalize = path => path.replace(/\/$/, '');
  const targets = new Set([...document.querySelectorAll('.parts-directory a[href]')].map(a => normalize(new URL(a.href, location.origin).pathname)));
  const categories = new Map([...document.querySelectorAll('.parts-directory [data-vehicle-category]')].map(a => [normalize(new URL(a.href, location.origin).pathname),a.dataset.vehicleCategory]));
  const allPath = garage.dataset.allUrl || '/collections/all';
  targets.add(normalize(new URL(allPath,location.origin).pathname).replace(/\/all$/, '/suspension-steering'));
  const read = () => { try { return localStorage.getItem(key) || ''; } catch { return ''; } };
  let selected = '', ranges = {}, index = {}, collections = {};
  const valid = value => !!ranges[value]?.length && !!collections[value.split('|')[1]];
  const label = value => value.split('|').join(' / ');
  const allPartsURL = (vehicle = selected) => {
    const url = new URL(collections[vehicle.split('|')[1]] || allPath, location.origin);
    return urlFor(url.href, vehicle);
  };
  const urlFor = (href, vehicle = selected) => {
    let url = new URL(href, location.origin);
    // Make collections stay within Shopify's native filter capacity and include
    // all published applications, including parts unavailable for purchase.
    if (valid(vehicle) && (categories.has(normalize(url.pathname)) || /\/collections\/(all|suspension-steering|am-vehicle-[^/]+)\/?$/.test(url.pathname))) {
      const category = categories.get(normalize(url.pathname));
      const suspension = /suspension-steering\/?$/.test(url.pathname);
      const params = url.searchParams;
      url = new URL(collections[vehicle.split('|')[1]] || allPath, location.origin);
      url.search = params.toString();
      if (suspension) url.searchParams.set('filter.p.m.amoffroad.category', 'Suspension & Steering');
      if (category) url.searchParams.set('filter.p.m.amoffroad.category', category);
    }
    url.searchParams.delete(param); url.searchParams.delete('am_vehicle'); url.searchParams.delete('page');
    if (valid(vehicle)) { ranges[vehicle].forEach(value => url.searchParams.append(param, value)); url.searchParams.set('am_vehicle', vehicle); }
    return url.pathname + url.search + url.hash;
  };
  const fromURL = () => {
    const params = new URLSearchParams(location.search), value = params.get('am_vehicle') || read();
    const actual = [...new Set(params.getAll(param).flatMap(x => x.split(',')).filter(Boolean))].sort();
    return valid(value) && JSON.stringify(actual) === JSON.stringify([...ranges[value]].sort()) ? value : '';
  };
  const update = () => {
    const applied = fromURL();
    if (applied) document.querySelectorAll('.pagination a[href], .active-filters a[href]:not([data-clear-vehicle])').forEach(link => {
      const url = new URL(link.href,location.origin);
      const actual = [...new Set(url.searchParams.getAll(param).flatMap(v=>v.split(',')).filter(Boolean))].sort();
      if (JSON.stringify(actual) === JSON.stringify([...ranges[applied]].sort())) { url.searchParams.set('am_vehicle',applied); link.href=url.href; }
    });
    garage.querySelector('[data-saved-vehicle]').textContent = selected ? 'Saved vehicle: ' + label(selected) : 'Find parts for your vehicle';
    garage.querySelector('[data-open-vehicle]').textContent = selected ? 'Change' : 'Choose vehicle';
    garage.querySelector('[data-forget-vehicle]').hidden = !selected;
    document.querySelector('[data-parts-vehicle-note]').textContent = selected ? 'Show listed applications for ' + label(selected) + '. Check requirements on each part page.' : 'Browse parts by category.';
    document.querySelectorAll('a[href]').forEach(link => {
      if (link.closest('.active-filters, .pagination') || link.matches('[data-clear-vehicle], [data-open-vehicle], [data-open-parts]')) return;
      const original = link.dataset.vehicleOriginalHref || link.getAttribute('href');
      const url = new URL(original, location.origin);
      if (url.origin !== location.origin || !targets.has(normalize(url.pathname))) return;
      link.dataset.vehicleOriginalHref = original;
      link.href = selected ? urlFor(original) : original;
    });
    const prompt = document.querySelector('[data-saved-vehicle-action]');
    if (prompt) {
      prompt.replaceChildren(); prompt.hidden = !selected || !!fromURL();
      if (!prompt.hidden) {
        if (targets.has(normalize(location.pathname))) {
          prompt.append('Browsing all vehicles. ');
          const a = document.createElement('a'); a.href = urlFor(location.href); a.textContent = 'Show applications for ' + label(selected); prompt.append(a);
        } else {
          const a = document.createElement('a'); a.href = allPartsURL(); a.textContent = 'View all parts for ' + label(selected); prompt.append(a);
        }
      }
    }
    const fitment = document.querySelector('[data-selected-vehicle-fitment]');
    if (fitment) {
      fitment.hidden = !selected;
      let applications = []; try { applications = JSON.parse(document.querySelector('[data-product-vehicle-keys]')?.textContent || '[]') || []; } catch {}
      const matches = selected && ranges[selected].some(value => applications.includes(value));
      fitment.textContent = !selected ? '' : matches ? label(selected) + ' appears in this part’s listed applications. Confirm the trim, engine and installation requirements below.' : 'Fitment is not confirmed for ' + label(selected) + '. Check the product specifications before ordering.';
    }
  };
  const remember = value => {
    selected = valid(value) ? value : '';
    try { if (selected) localStorage.setItem(key, selected); else localStorage.removeItem(key); } catch {}
    update(); document.dispatchEvent(new CustomEvent('am:vehicle-change', {detail: {vehicle: selected}}));
  };
  const option = (text, value) => { const node = document.createElement('option'); node.textContent = text; node.value = value; return node; };
  const fill = (select, values, title) => { select.replaceChildren(option(title, ''), ...values.map(v => option(v, v))); select.disabled = !values.length; };
  const fillMakes = () => { fill(make, Object.keys(index[year.value] || {}).sort(), 'Select make'); fill(model, [], 'Select make first'); };
  const fillModels = () => fill(model, index[year.value]?.[make.value] || [], 'Select model');
  const restoreForm = () => {
    const [y,m,mo] = selected.split('|'); year.value = y || ''; fillMakes();
    if (index[y]?.[m]) { make.value = m; fillModels(); model.value = mo; }
  };
  const show = target => {
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    if (typeof closeMenu === 'function') closeMenu();
    target.showModal();
  };
  document.querySelectorAll('[data-open-vehicle]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); restoreForm(); show(dialog); }));
  document.querySelectorAll('[data-open-parts]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); show(parts); }));
  year.addEventListener('change', fillMakes); make.addEventListener('change', fillModels);
  garage.querySelector('[data-forget-vehicle]').addEventListener('click', () => {
    const applied = fromURL(); remember('');
    if (applied) location.assign(urlFor(location.href, ''));
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-clear-vehicle], [data-clear="am_vehicle"], [data-clear="all"]')) remember('');
  });
  form.addEventListener('submit', event => {
    event.preventDefault(); const vehicle = [year.value, make.value, model.value].join('|');
    if (!valid(vehicle)) { feedback.textContent = 'Select a year, make and model.'; return; }
    remember(vehicle); location.assign(allPartsURL());
  });
  const loadJSON = url => fetch(url).then(r => { if (!r.ok) throw Error(); return r.json(); });
  const ready = loadJSON(garage.dataset.fitmentUrl).then(data => {
    if (!data.index || !data.ranges || !data.collections) throw Error('Incomplete vehicle index');
    index = data.index; ranges = data.ranges; collections = data.collections;
    fill(year, Object.keys(index).sort((a,b) => Number(b)-Number(a)), 'Select year');
    remember(fromURL() || read()); restoreForm(); feedback.textContent = '';
    form.querySelector('[data-garage-submit]').disabled = false;
    const heading = document.querySelector('[data-vehicle-results-heading]');
    if (heading && fromURL()) heading.textContent = 'PARTS FOR ' + label(fromURL());
    return {index, ranges, collections};
  }).catch(() => { feedback.textContent = 'Vehicle options could not load. Please reload or shop by part.'; return null; });
  window.AMVehicle = {ready, remember, urlFor, allPartsURL, get selected() { return selected; }};
  addEventListener('popstate', () => { const vehicle = fromURL(); if (vehicle) remember(vehicle); else update(); });
  addEventListener('pageshow', () => ready.then(() => { const vehicle = fromURL() || read(); if (vehicle !== selected) remember(vehicle); }));
  addEventListener('storage', event => { if (event.key === key) { selected = valid(event.newValue) ? event.newValue : ''; update(); } });
})();
